function createToSorted() {
  if (Array.prototype.toSorted) return Array.prototype.toSorted
  return function toSorted<T>(
    this: T[],
    compareFn?: (a: T, b: T) => number
  ): T[] {
    // eslint-disable-next-line unicorn/no-array-sort
    return this.slice().sort(compareFn)
  }
}

const internalToSorted = createToSorted()

export function toSorted<T>(
  thisArg?: T[],
  compareFn?: (a: T, b: T) => number
): T[] {
  if (thisArg === undefined || thisArg === null) return []
  return internalToSorted.call(thisArg, compareFn)
}
